export enum AtlasType {
  GOOGLE = 'Google',
  LEAFLET = 'Leaflet',
}

export type AtlasSize = {
  width: number;
  height: number;
};

export type AtlasPoint = {
  x: number;
  y: number;
};

export type AtlasPosition = {
  lat: number;
  lng: number;
};

export type AtlasMarkerOptions = {
  position: AtlasPosition;
  label?: AtlasLabel;
  icon?: AtlasIcon;
  popup?: AtlasPopup;
  draggable?: boolean;
};

export type AtlasIconOptions = {
  url: string;
  size?: AtlasSize;
  anchor?: AtlasPoint;
  labelOrigin?: AtlasPoint;
  className: string;
};

export type AtlasLabelOptions = {
  text: string;
  color?: string;
  fontSize?: string;
  fontFamily?: string;
  className?: string;
};

export type AtlasPopupOptions = {
  maxWidth: string;
  content: string;
  minWidth: string;
  autoClose: boolean;
  closeButton: boolean;
  className: string;
  buttons?: AtlasPopupButtons[];
};

export type AtlasPopupButtons = {
  className: string;
  value: string;
  type: string;
  data: any;
};

export type AtlasPolygonOptions = {
  paths: AtlasPosition[];
  strokeColor?: string;
  strokeOpacity?: number;
  strokeWeight?: number;
  fillColor?: string;
  fillOpacity?: number;
};

export interface AtlasIcon {
  readonly url: string;
  readonly size: AtlasSize;
  readonly anchor: AtlasPoint;
  readonly labelOrigin: AtlasPoint;
  readonly className: string;
}

export interface AtlasLabel {
  readonly text: string;
  readonly color: string;
  readonly fontSize: string;
  readonly fontFamily: string;
  readonly className: string;
}

export interface AtlasPopup {
  readonly maxWidth: string;
  readonly content: string;
  readonly minWidth: string;
  readonly autoClose: boolean;
  readonly closeButton: boolean;
  readonly className: string;
  readonly buttons?: AtlasPopupButtons[];
}

export interface AtlasBounds {
  extend(position: AtlasPosition): void;
  getCenter(): AtlasPosition;
  getNorthEast(): AtlasPosition;
  getSouthWest(): AtlasPosition;
}

export interface AtlasMapElement {
  getElementForMap(): any;
  setValues(value: any): void;
  get(key: string): any;
}
